import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dVoid from "../Data.Void/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dInternal from "../Foreign.Generic.Internal/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record$dBuilder from "../Record.Builder/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $Arg = (tag, _1) => ({tag, _1});
const $SumEncoding = _1 => ({tag: "TaggedObject", _1});
const applicativeExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
const readString = /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String");
const mempty = v => Data$dList$dTypes.Nil;
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const identity = x => x;
const identity1 = x => x;
const bindExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity);
const index = /* #__PURE__ */ (() => Foreign$dIndex.indexString(Data$dIdentity.monadIdentity).index)();
const alt = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.altExceptT(Data$dList$dTypes.semigroupNonEmptyList)(Data$dIdentity.monadIdentity).alt)();
const sequence = /* #__PURE__ */ (() => Foreign$dObject.traversableWithIndexObject.traverseWithIndex(applicativeExceptT)(v => Foreign$dObject.identity))();
const toUnfoldable = /* #__PURE__ */ Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
const readArray = /* #__PURE__ */ Foreign.readArray(Data$dIdentity.monadIdentity);
const fromFoldable = /* #__PURE__ */ Data$dFoldable.foldrArray(Data$dList$dTypes.Cons)(Data$dList$dTypes.Nil);
const sequence1 = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(applicativeExceptT)(Data$dTraversable.identity))();
const TaggedObject = value0 => $SumEncoding(value0);
const RecArg = value0 => $Arg("RecArg", value0);
const PlainArg = value0 => $Arg("PlainArg", value0);
const voidEncode = {encode: Data$dVoid.absurd};
const voidDecode = {decode: v => Data$dEither.$Either("Left", Data$dNonEmpty.$NonEmpty(Foreign.$ForeignError("ForeignError", "Decode: void"), Data$dList$dTypes.Nil))};
const unitEncode = {encode: v => []};
const unitDecode = {decode: v => applicativeExceptT.pure()};
const unArg = v => {
  if (v.tag === "RecArg") { return v._1; }
  if (v.tag === "PlainArg") { return v._1; }
  $runtime.fail();
};
const stringEncode = {encode: Unsafe$dCoerce.unsafeCoerce};
const stringDecode = {decode: readString};
const numberEncode = {encode: Unsafe$dCoerce.unsafeCoerce};
const numberDecode = {decode: /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("Number")};
const intEncode = {encode: Unsafe$dCoerce.unsafeCoerce};
const intDecode = {decode: /* #__PURE__ */ Foreign.readInt(Data$dIdentity.monadIdentity)};
const genericEncodeArgsNoArguments = {encodeArgs: v => mempty};
const genericDecodeNoConstructors = {decodeOpts: opts => v => fail(Foreign.$ForeignError("ForeignError", "No constructors"))};
const genericDecodeArgsNoArguments = {
  decodeArgs: v => v1 => v2 => {
    if (v2.tag === "Nil") { return applicativeExceptT.pure({result: Data$dGeneric$dRep.NoArguments, rest: Data$dList$dTypes.Nil, next: v1}); }
    return fail(Foreign.$ForeignError("ForeignError", "Too many constructor arguments"));
  },
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const genericCountArgsNoArguments = {countArgs: v => Data$dEither.$Either("Left", Data$dGeneric$dRep.NoArguments)};
const genericCountArgsArgument = {countArgs: v => Data$dEither.$Either("Right", 1)};
const foreignEncode = {encode: identity};
const foreignDecode = /* #__PURE__ */ (() => ({decode: applicativeExceptT.pure}))();
const encodeWithOptions = dict => dict.encodeWithOptions;
const genericEncodeArgsArgument = dictEncodeWithOptions => (
  {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", $Arg("PlainArg", dictEncodeWithOptions.encodeWithOptions(opts)(v)), Data$dList$dTypes.Nil)}
);
const genericEncodeArgsRecord = dictEncodeWithOptions => (
  {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", $Arg("RecArg", dictEncodeWithOptions.encodeWithOptions(opts)(v)), Data$dList$dTypes.Nil)}
);
const encodeRecordWithOptions = dict => dict.encodeRecordWithOptions;
const encodeWithOptionsRecord = () => dictEncodeRecord => ({encodeWithOptions: opts => dictEncodeRecord.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)});
const encodeRecordNil = {encodeRecordWithOptions: v => v1 => v2 => Foreign$dObject.empty};
const encodeRecordCons = () => dictEncodeRecord => dictIsSymbol => dictEncodeWithOptions => (
  {
    encodeRecordWithOptions: v => opts => rec => {
      const $0 = opts.fieldTransform(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy));
      const $1 = dictEncodeWithOptions.encodeWithOptions(opts)(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(rec));
      return Foreign$dObject.mutate($2 => () => {
        $2[$0] = $1;
        return $2;
      })(dictEncodeRecord.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(rec));
    }
  }
);
const encodeOpts = dict => dict.encodeOpts;
const genericEncodeNoConstructors = {encodeOpts: opts => a => genericEncodeNoConstructors.encodeOpts(opts)(a)};
const genericEncodeSum = dictGenericEncode => dictGenericEncode1 => (
  {
    encodeOpts: v => v1 => {
      if (v1.tag === "Inl") { return dictGenericEncode.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
      if (v1.tag === "Inr") { return dictGenericEncode1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
      $runtime.fail();
    }
  }
);
const encodeArgs = dict => dict.encodeArgs;
const genericEncodeArgsProduct = dictGenericEncodeArgs => dictGenericEncodeArgs1 => (
  {
    encodeArgs: opts => v => Data$dList$dTypes.foldableList.foldr(Data$dList$dTypes.Cons)(dictGenericEncodeArgs1.encodeArgs(opts)(v._2))(dictGenericEncodeArgs.encodeArgs(opts)(v._1))
  }
);
const encode = dict => dict.encode;
const encodeWithOptionsOther = dictEncode => {
  const encode1 = dictEncode.encode;
  return {encodeWithOptions: v => encode1};
};
const identityEncode = dictEncode => ({encode: x => dictEncode.encode(x)});
const maybeEncode = dictEncode => (
  {
    encode: v2 => {
      if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
      if (v2.tag === "Just") { return dictEncode.encode(v2._1); }
      $runtime.fail();
    }
  }
);
const objectEncode = dictEncode => {
  const encode1 = dictEncode.encode;
  return {encode: x => Foreign$dObject._mapWithKey(x, v => encode1)};
};
const defaultOptions = {
  sumEncoding: /* #__PURE__ */ $SumEncoding({tagFieldName: "tag", contentsFieldName: "contents", constructorTagTransform: identity}),
  unwrapSingleConstructors: false,
  unwrapSingleArguments: true,
  unwrapSingleRecordArguments: false,
  fieldTransform: identity
};
const recordEncode = () => dictEncodeRecord => ({encode: dictEncodeRecord.encodeRecordWithOptions(Type$dProxy.Proxy)(defaultOptions)});
const decodeWithOptions = dict => dict.decodeWithOptions;
const decodeSingleRecordArg = dict => dict.decodeSingleRecordArg;
const decodeRecordWithOptions = dict => dict.decodeRecordWithOptions;
const decodeWithOptionsRecord = () => dictDecodeRecord => (
  {
    decodeWithOptions: opts => {
      const $0 = dictDecodeRecord.decodeRecordWithOptions(Type$dProxy.Proxy)(opts);
      return x => {
        const $1 = $0(x);
        if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
        if ($1.tag === "Right") { return Data$dEither.$Either("Right", $1._1({})); }
        $runtime.fail();
      };
    }
  }
);
const recordDecode = () => dictDecodeRecord => ({decode: decodeWithOptionsRecord()(dictDecodeRecord).decodeWithOptions(defaultOptions)});
const decodeRecordNil = {decodeRecordWithOptions: v => v1 => v2 => applicativeExceptT.pure(identity1)};
const decodeRecordCons = () => dictDecodeRecord => dictIsSymbol => dictDecodeWithOptions => () => (
  {
    decodeRecordWithOptions: v => opts => f => bindExceptT.bind(dictDecodeRecord.decodeRecordWithOptions(Type$dProxy.Proxy)(opts)(f))(builder => {
      const l_transformed = opts.fieldTransform(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy));
      return bindExceptT.bind(index(f)(l_transformed))(f_ => bindExceptT.bind(Data$dBifunctor.bifunctorEither.bimap(Data$dList$dTypes.functorNonEmptyList.map(Foreign.ErrorAtProperty(l_transformed)))(Data$dBifunctor.identity)(dictDecodeWithOptions.decodeWithOptions(opts)(f_)))(a => applicativeExceptT.pure(x => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(a)(builder(x)))));
    })
  }
);
const decodeOpts = dict => dict.decodeOpts;
const genericDecodeSum = dictGenericDecode => dictGenericDecode1 => (
  {
    decodeOpts: opts => f => {
      const opts$p = {...opts, unwrapSingleConstructors: false};
      return alt((() => {
        const $0 = dictGenericDecode.decodeOpts(opts$p)(f);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dGeneric$dRep.$Sum("Inl", $0._1)); }
        $runtime.fail();
      })())((() => {
        const $0 = dictGenericDecode1.decodeOpts(opts$p)(f);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dGeneric$dRep.$Sum("Inr", $0._1)); }
        $runtime.fail();
      })());
    }
  }
);
const decodeArgsArgument = dictDecodeWithOptions => v => v1 => v2 => {
  if (v2.tag === "Cons") {
    const $0 = v2._2;
    return bindExceptT.bind(Data$dBifunctor.bifunctorEither.bimap(Data$dList$dTypes.functorNonEmptyList.map(Foreign.ErrorAtIndex(v1)))(Data$dBifunctor.identity)(dictDecodeWithOptions.decodeWithOptions(v)(v2._1)))(a => applicativeExceptT.pure({
      result: a,
      rest: $0,
      next: v1 + 1 | 0
    }));
  }
  return fail(Foreign.$ForeignError("ForeignError", "Not enough constructor arguments"));
};
const genericDecodeArgsArgument = dictDecodeWithOptions => ({decodeArgs: decodeArgsArgument(dictDecodeWithOptions), decodeSingleRecordArg: Data$dMaybe.Nothing});
const genericDecodeArgsRecord = dictDecodeWithOptions => (
  {
    decodeArgs: decodeArgsArgument(dictDecodeWithOptions),
    decodeSingleRecordArg: Data$dMaybe.$Maybe(
      "Just",
      options => i => {
        const $0 = dictDecodeWithOptions.decodeWithOptions(options)(i);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return Data$dEither.$Either("Right", $0._1); }
        $runtime.fail();
      }
    )
  }
);
const decodeArgs = dict => dict.decodeArgs;
const genericDecodeArgsProduct = dictGenericDecodeArgs => dictGenericDecodeArgs1 => (
  {
    decodeArgs: opts => i => xs => bindExceptT.bind(dictGenericDecodeArgs.decodeArgs(opts)(i)(xs))(v => {
      const $0 = v.result;
      return bindExceptT.bind(dictGenericDecodeArgs1.decodeArgs(opts)(v.next)(v.rest))(v1 => applicativeExceptT.pure({
        result: Data$dGeneric$dRep.$Product($0, v1.result),
        rest: v1.rest,
        next: v1.next
      }));
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  }
);
const decode = dict => dict.decode;
const decodeWithOptionsOther = dictDecode => {
  const decode2 = dictDecode.decode;
  return {decodeWithOptions: v => decode2};
};
const identityDecode = dictDecode => (
  {
    decode: x => {
      const $0 = dictDecode.decode(x);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", $0._1); }
      $runtime.fail();
    }
  }
);
const maybeDecode = dictDecode => ({decode: Foreign$dNullOrUndefined.readNullOrUndefined(dictDecode.decode)});
const objectDecode = dictDecode => {
  const decode2 = dictDecode.decode;
  return {decode: a => bindExceptT.bind(Foreign$dGeneric$dInternal.readObject(a))(x => sequence(Foreign$dObject._mapWithKey(x, v => decode2)))};
};
const decode1 = /* #__PURE__ */ (() => objectDecode(foreignDecode).decode)();
const genericEncodeConstructor = dictIsSymbol => dictGenericEncodeArgs => (
  {
    encodeOpts: opts => v => {
      const encodeArgsArray = encoding => {
        const $0 = dictGenericEncodeArgs.encodeArgs(opts);
        return x => {
          const $1 = toUnfoldable($0(x));
          if ($1.length === 0) { return encoding.noArgs; }
          const v3 = v4 => {
            if ($1.length === 1) {
              if (opts.unwrapSingleArguments) {
                return encoding.default((() => {
                  if ($1[0].tag === "RecArg") { return $1[0]._1; }
                  if ($1[0].tag === "PlainArg") { return $1[0]._1; }
                  $runtime.fail();
                })());
              }
              return encoding.default(Data$dFunctor.arrayMap(unArg)($1));
            }
            return encoding.default(Data$dFunctor.arrayMap(unArg)($1));
          };
          if ($1.length === 1) {
            if ($1[0].tag === "RecArg") {
              const $2 = decode1($1[0]._1);
              if ($2.tag === "Right") { return encoding.singleRecord($2._1); }
              return v3(true);
            }
            return v3(true);
          }
          return v3(true);
        };
      };
      const ctorName = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
      if (opts.unwrapSingleConstructors) { return encodeArgsArray({noArgs: {}, singleRecord: Unsafe$dCoerce.unsafeCoerce, default: identity})(v); }
      const $0 = opts.sumEncoding._1.contentsFieldName;
      const $1 = opts.sumEncoding._1.tagFieldName;
      return Foreign$dObject.union((() => {
        const $2 = opts.sumEncoding._1.constructorTagTransform(ctorName);
        return (() => {
          const $3 = {};
          $3[$1] = $2;
          return $3;
        })();
      })())(encodeArgsArray({
        noArgs: Foreign$dObject.empty,
        singleRecord: r => {
          if (opts.unwrapSingleRecordArguments) { return r; }
          return (() => {
            const $2 = {};
            $2[$0] = r;
            return $2;
          })();
        },
        default: Foreign$dObject.singleton($0)
      })(v));
    }
  }
);
const countArgs = dict => dict.countArgs;
const genericCountArgsProduct = dictGenericCountArgs => dictGenericCountArgs1 => (
  {
    countArgs: v => {
      const v1 = dictGenericCountArgs1.countArgs(Type$dProxy.Proxy);
      const v2 = dictGenericCountArgs.countArgs(Type$dProxy.Proxy);
      if (v2.tag === "Left") {
        if (v1.tag === "Left") { return Data$dEither.$Either("Left", Data$dGeneric$dRep.$Product(v2._1, v1._1)); }
        if (v1.tag === "Right") { return Data$dEither.$Either("Right", v1._1); }
        $runtime.fail();
      }
      if (v2.tag === "Right") {
        if (v1.tag === "Left") { return Data$dEither.$Either("Right", v2._1); }
        if (v1.tag === "Right") { return Data$dEither.$Either("Right", v2._1 + v1._1 | 0); }
        $runtime.fail();
      }
      $runtime.fail();
    }
  }
);
const genericDecodeConstructor = dictIsSymbol => dictGenericDecodeArgs => {
  const decodeSingleRecordArg1 = dictGenericDecodeArgs.decodeSingleRecordArg;
  return dictGenericCountArgs => (
    {
      decodeOpts: opts => f => {
        const numArgs = dictGenericCountArgs.countArgs(Type$dProxy.Proxy);
        const readArguments = args => {
          const $0 = n => bindExceptT.bind(readArray(args))(vals => bindExceptT.bind(dictGenericDecodeArgs.decodeArgs(opts)(0)(fromFoldable(vals)))(v => {
            const $0 = v.result;
            return bindExceptT.bind((() => {
              const $1 = v.rest.tag === "Nil";
              const $2 = fail(Foreign.$ForeignError("ForeignError", "Expected " + Data$dShow.showIntImpl(n) + " constructor arguments"));
              if (!$1) { return $2; }
              if ($1) { return applicativeExceptT.pure(); }
              $runtime.fail();
            })())(() => applicativeExceptT.pure($0));
          }));
          if (numArgs.tag === "Left") { return applicativeExceptT.pure(numArgs._1); }
          if (numArgs.tag === "Right") {
            if (numArgs._1 === 1) {
              if (opts.unwrapSingleArguments) {
                return bindExceptT.bind(dictGenericDecodeArgs.decodeArgs(opts)(0)(Data$dList$dTypes.$List("Cons", args, Data$dList$dTypes.Nil)))(v => {
                  const $1 = v.result;
                  return bindExceptT.bind((() => {
                    const $2 = v.rest.tag === "Nil";
                    const $3 = fail(Foreign.$ForeignError("ForeignError", "Expected a single argument"));
                    if (!$2) { return $3; }
                    if ($2) { return applicativeExceptT.pure(); }
                    $runtime.fail();
                  })())(() => applicativeExceptT.pure($1));
                });
              }
              return $0(numArgs._1);
            }
            return $0(numArgs._1);
          }
          $runtime.fail();
        };
        const ctorName = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
        if (opts.unwrapSingleConstructors) {
          const $0 = readArguments(f);
          if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
          if ($0.tag === "Right") { return Data$dEither.$Either("Right", $0._1); }
          $runtime.fail();
        }
        const $0 = opts.sumEncoding._1.contentsFieldName;
        return bindExceptT.bind(Data$dBifunctor.bifunctorEither.bimap(Data$dList$dTypes.functorNonEmptyList.map(Foreign.ErrorAtProperty(opts.sumEncoding._1.tagFieldName)))(Data$dBifunctor.identity)(bindExceptT.bind(bindExceptT.bind(index(f)(opts.sumEncoding._1.tagFieldName))(readString))(tag => {
          const expected = opts.sumEncoding._1.constructorTagTransform(ctorName);
          return bindExceptT.bind((() => {
            const $1 = tag === expected;
            const $2 = fail(Foreign.$ForeignError("ForeignError", "Expected " + Data$dShow.showStringImpl(expected) + " tag"));
            if (!$1) { return $2; }
            if ($1) { return applicativeExceptT.pure(); }
            $runtime.fail();
          })())(() => applicativeExceptT.pure(tag));
        })))(tag => bindExceptT.bind((() => {
          const $1 = () => Data$dBifunctor.bifunctorEither.bimap(Data$dList$dTypes.functorNonEmptyList.map(Foreign.ErrorAtProperty($0)))(Data$dBifunctor.identity)(bindExceptT.bind(index(f)($0))($1 => readArguments($1)));
          if (decodeSingleRecordArg1.tag === "Just") {
            if (opts.unwrapSingleRecordArguments) { return decodeSingleRecordArg1._1(opts)(f); }
            return $1();
          }
          return $1();
        })())(args => applicativeExceptT.pure(args)));
      }
    }
  );
};
const charEncode = {encode: Unsafe$dCoerce.unsafeCoerce};
const charDecode = {decode: /* #__PURE__ */ Foreign.readChar(Data$dIdentity.monadIdentity)};
const booleanEncode = {encode: Unsafe$dCoerce.unsafeCoerce};
const booleanDecode = {decode: /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("Boolean")};
const arrayEncode = dictEncode => ({encode: Data$dFunctor.arrayMap(dictEncode.encode)});
const arrayDecode = dictDecode => (
  {
    decode: a => bindExceptT.bind(readArray(a))(arr => sequence1(Data$dArray.zipWithImpl(
      i => value => Data$dBifunctor.bifunctorEither.bimap(Data$dList$dTypes.functorNonEmptyList.map(Foreign.ErrorAtIndex(i)))(Data$dBifunctor.identity)(dictDecode.decode(value)),
      Data$dArray.rangeImpl(0, arr.length),
      arr
    )))
  }
);
export {
  $Arg,
  $SumEncoding,
  PlainArg,
  RecArg,
  TaggedObject,
  alt,
  applicativeExceptT,
  arrayDecode,
  arrayEncode,
  bindExceptT,
  booleanDecode,
  booleanEncode,
  charDecode,
  charEncode,
  countArgs,
  decode,
  decode1,
  decodeArgs,
  decodeArgsArgument,
  decodeOpts,
  decodeRecordCons,
  decodeRecordNil,
  decodeRecordWithOptions,
  decodeSingleRecordArg,
  decodeWithOptions,
  decodeWithOptionsOther,
  decodeWithOptionsRecord,
  defaultOptions,
  encode,
  encodeArgs,
  encodeOpts,
  encodeRecordCons,
  encodeRecordNil,
  encodeRecordWithOptions,
  encodeWithOptions,
  encodeWithOptionsOther,
  encodeWithOptionsRecord,
  fail,
  foreignDecode,
  foreignEncode,
  fromFoldable,
  genericCountArgsArgument,
  genericCountArgsNoArguments,
  genericCountArgsProduct,
  genericDecodeArgsArgument,
  genericDecodeArgsNoArguments,
  genericDecodeArgsProduct,
  genericDecodeArgsRecord,
  genericDecodeConstructor,
  genericDecodeNoConstructors,
  genericDecodeSum,
  genericEncodeArgsArgument,
  genericEncodeArgsNoArguments,
  genericEncodeArgsProduct,
  genericEncodeArgsRecord,
  genericEncodeConstructor,
  genericEncodeNoConstructors,
  genericEncodeSum,
  identity,
  identity1,
  identityDecode,
  identityEncode,
  index,
  intDecode,
  intEncode,
  maybeDecode,
  maybeEncode,
  mempty,
  numberDecode,
  numberEncode,
  objectDecode,
  objectEncode,
  readArray,
  readString,
  recordDecode,
  recordEncode,
  sequence,
  sequence1,
  stringDecode,
  stringEncode,
  toUnfoldable,
  unArg,
  unitDecode,
  unitEncode,
  voidDecode,
  voidEncode
};
